import React from 'react'
import { Autocomplete, autocompleteClasses, inputBaseClasses, Skeleton, TextField } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'
import uniqBy from 'lodash/uniqBy'

import { useGetSbpParticipants } from '../../../../services'
import { B2CTransferRequestForm, SbpParticipant } from '../../../../@types/b2c.types.ts'
import { Icon } from '../../../../components'

export const SbpParticipantsField = (): React.ReactElement => {
  const { data, isLoading, isFetching } = useGetSbpParticipants()
  const { formState, control, getFieldState } = useFormContext<B2CTransferRequestForm>()

  if (isLoading || isFetching) {
    return <Skeleton width="100%" height={48} />
  }

  const rcvBankMemberIdControl = getFieldState('rcvBankMemberId')

  const filterOps = (bankMembers: SbpParticipant[], inputState: { inputValue: string }) => {
    const query = inputState.inputValue.toLowerCase().trim()

    return bankMembers.filter(({ memberNameRus }) => memberNameRus.toLowerCase().includes(query))
  }

  return (
    <Controller
      name="rcvBankMemberId"
      control={control}
      render={({ field }) => {
        const options = uniqBy(data?.data.participants ?? [], 'memberId')
        const value = options.find((option) => option.memberId === field.value) ?? null

        return (
          <Autocomplete
            disabled={formState.isSubmitting}
            popupIcon={<Icon name="ArrowDown" />}
            sx={{
              [`& .${inputBaseClasses.root}`]: {
                paddingTop: '21px',
                paddingLeft: '20px',
                [`& .${autocompleteClasses.input}`]: { px: 0, py: 0 },
              },
            }}
            options={options}
            value={value}
            onChange={(_, option) => field.onChange(option?.memberId ?? null)}
            filterOptions={filterOps}
            isOptionEqualToValue={(option, value) => option.memberId === value.memberId}
            getOptionLabel={(option) => option.memberNameRus ?? ''}
            getOptionKey={(option) => option.memberId}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Банк получателя"
                error={!!rcvBankMemberIdControl?.error?.message}
                helperText={rcvBankMemberIdControl?.error?.message}
              />
            )}
          />
        )
      }}
    />
  )
}
